import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.course'),
      field: 'course.name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { course } = rowData;
        return (
          <span className="tooltip-test" title={course.name}>
            {course.name}
          </span>
        );
      },
    },
    {
      title: t('general.year-level'),
      field: 'courseStep.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { courseStep } = rowData;
        return (
          <span className="tooltip-test" title={courseStep.fullName}>
            {courseStep.fullName}
          </span>
        );
      },
    },
    {
      title: t('general.cycle'),
      field: 'cycleNumber',
    },
    {
      title: t('general.time-period'),
      field: 'period.name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { period } = rowData;
        return (
          <span className="tooltip-test" title={period.name}>
            {period.name}
          </span>
        );
      },
    },
    {
      title: t('general.status'),
      field: 'status',
    },
  ];
}
